export default __webpack_public_path__ + "static/char-thumb-52-01b65709ac48f4c3ca18fa4a9204489f.webp";